export default class DegreeOfUrgency {}
DegreeOfUrgency.Serious = 'SERIOUS';
DegreeOfUrgency.Moderate = 'MODERATE';
DegreeOfUrgency.Minor = 'MINOR';
